import React, { FC } from 'react';

import { PostProps } from '~types';

import { Post } from '../../../templates/Post';

export const Full: FC<Pick<PostProps, 'post'>> = ({ post }) => <Post post={post} nextPosts={[]} />;
